import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner, Container, Row, Col } from "react-bootstrap";
import { userAccountDetails, logout } from "../slices/keycloakSlice";
import Message from "../components/Message";
import "./Common.css";

import Header from "../components/Header";
import Footer from "../components/Footer";

function AccountPage({ envIsNoAuth }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo, loading } = useSelector((state) => state.user);

  const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");

  useEffect(() => {
    if (!envIsNoAuth) {
      if (!keycloak?.authenticated) {
        navigate("/"); // home
      } else {
        try {
          dispatch(userAccountDetails(keycloak?.token));
        } catch (error) {
          navigate("/");
        }
      }
    }
  }, [
    envIsNoAuth,
    keycloak?.authenticated,
    keycloak?.token,
    dispatch,
    navigate,
  ]);

  const logoutHandler = () => {
    dispatch(logout());
    navigate("/"); // home
  };

  const handleRoleChange = (event) => {
    const selectedRole = event.target.value;

    if (selectedRole !== "default") {
      console.log("selected role: ", selectedRole);
    }
  };

  const renderData = () => {
    try {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header />

          <div style={{ flex: 1 }}>
            {loading && (
              <span style={{ display: "flex", padding: "20px" }}>
                <h5>Getting User Information</h5>
                <span className="ml-2">
                  <Spinner animation="border" />
                </span>
              </span>
            )}

            {/* <div
              className="d-flex flex-column flex-md-row align-items-center mt-3 mb-3"
              style={{ padding: "0 20px" }}
            >
              <label
                htmlFor="project"
                className="navbar-text mb-2 mb-md-0 me-md-3"
                style={{ fontSize: "20px" }}
              >
                Change your project:
              </label>
              <select
                name="project"
                onChange={handleRoleChange}
                className="custom-select m-0"
              >
                <option value="default">{userInfo.current_project}</option>
                {userInfo.projects &&
                  userInfo.projects.map((project, index) => {
                    if (project !== userInfo.current_project) {
                      return (
                        <option key={index} value={project}>
                          {project}
                        </option>
                      );
                    }
                    return null;
                  })}
              </select>
            </div> */}

            <Container style={{ padding: "20px" }}>
              {/* Account Details */}
              <h3
                style={{
                  marginBottom: "15px",
                  color: "#333",
                  fontSize: "1.5rem",
                }}
              >
                Account Details
              </h3>
              {Object.keys(userInfo).length > 0 ? (
                Object.keys(userInfo).map((key) => (
                  <div key={key}>
                    <Row className="mb-2 border border-dark">
                      <Col
                        xs={4}
                        sm={4}
                        md={3}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className="p-3"
                        style={{
                          backgroundColor: "#9E6482BF",
                          textAlign: "center",
                          color: "white",
                          fontSize: "18px",
                          wordBreak: "break-word",
                        }}
                      >
                        {key}
                      </Col>
                      <Col className="p-3" style={{ wordBreak: "break-word" }}>
                        {userInfo[key] !== undefined && userInfo[key] !== ""
                          ? String(userInfo[key])
                          : "-"}
                      </Col>
                    </Row>
                  </div>
                ))
              ) : (
                <p>No details available for this user.</p>
              )}
            </Container>
          </div>
          <Footer />
        </div>
      );
    } catch (error) {
      return (
        <Message variant="danger">
          Something went wrong, go back to{" "}
          <Link onClick={logoutHandler} to={"/"}>
            {" "}
            Login
          </Link>{" "}
          page.
        </Message>
      );
    }
  };
  return renderData();
}

export default AccountPage;
